import { useSelector } from 'react-redux';

export function useIsMobile() {
  return useSelector(state => state.foundation.isMobile);
}
